import {ChangeDetectorRef, Component} from '@angular/core';
import { HttpClient } from "@angular/common/http";
import * as Highcharts from 'highcharts';
import {interval} from "rxjs";
import {IAppStatic} from "../../../interfaces";
import {StoreSelectorsService} from "../../../services";
import {basicTransition} from "../../../../libs/basicTransition";
import {timeout} from "../../../decorators/timeout";
import {TranslocoService} from "@ngneat/transloco";
import {startWith, switchMap} from 'rxjs/operators';
import {DEFAULT_NETWORK_STATUS} from "../../../common";
import {Compbaser} from "../../../components/compbaser";
import {retryWithBackoff} from "../../../../libs/rxjs/retryWithBackoff";
import {ToastrService} from "ngx-toastr";

@Component({
    selector: 'app-network-instances',
    templateUrl: './network-instances.component.html',
    animations: [basicTransition],
    styleUrls: ['./network-instances.component.scss']
})
export class NetworkInstancesComponent extends Compbaser {
    _options;
    _chart: any;
    _ready = false;
    Highcharts: typeof Highcharts = Highcharts;
    chartOptions: Highcharts.Options;
    private appSettings: IAppStatic;
    chartLabel;

    constructor(private storeSelector: StoreSelectorsService,
                private _http: HttpClient,
                private toastr: ToastrService,
                private cd: ChangeDetectorRef,
                private translocoService: TranslocoService) {
        super();
        this.cod(
            storeSelector.getAppSettings()
                .subscribe((appSettings: IAppStatic) => {
                    this.appSettings = appSettings;
                    this.networkStatus();
                })
        );
    }

    @timeout(1000)
    public networkStatus() {
        this.chartLabel = this.translocoService.translate('general.networkUsage', {}, this.translocoService.getActiveLang());
        const url = `${this.appSettings.globalService}/msInstanceStats`;
        this.cod(
            interval(DEFAULT_NETWORK_STATUS)
                .pipe(
                    startWith(0),
                    switchMap(() => this._http.get(url)
                        .pipe(retryWithBackoff(url, this.storeSelector, this.toastr)))
                )
                .subscribe((res: any) => {
                    const cats = [];
                    const data = [];
                    // tslint:disable-next-line
                    for (const value in res.instances) {
                        cats.push(res.instances[value].instanceId);
                        data.push(Math.round(res.instances[value].CPUUtilization));
                    }
                    this.initGrapha({data}, cats);
                }, (e) => console.error(e))
        );
    }

    logChartInstance(chart: Highcharts.Chart) {
        this._chart = chart;
    }

    chartCallback = (chart) => {
        setTimeout(() => {
            if (!chart || !chart.callback || chart.callback.length == 0) return;
            chart.reflow();
        }, 1);
    };

    initGrapha(i_versionData, categories) {
        this._options = {
            chart: {
                renderTo: 'chartContainer',
                reflow: true,
                type: 'column',
                borderColor: 'black',
                borderWidth: 0
            },
            responsive: {
                rules: [{
                    condition: {
                        maxWidth: '100%'
                    },
                    chartOptions: {
                        legend: {
                            align: 'center',
                            verticalAlign: 'bottom',
                            layout: 'horizontal'
                        },
                        yAxis: {
                            labels: {
                                align: 'left',
                                x: 0,
                                y: -5
                            },
                            title: {
                                text: null
                            }
                        },
                        subtitle: {
                            text: null
                        },
                        credits: {
                            enabled: false
                        }
                    }
                }]
            },
            title: {
                text: ''
            },
            xAxis: {
                categories,
                crosshair: true
            },
            yAxis: {
                min: 0,
                title: {
                    text: this.chartLabel
                }
            },
            tooltip: {
                headerFormat: `<span style="color: {series.color} !important">{point.key}</span><table style="color: white">`,
                pointFormat: `<tr><td style="color: var(--text-color1);padding:0">{series.name}: </td><td style="padding:0; color: var(--text-color1)"><b><span style="color: var(--text-color1)">{point.y:.1f} </span></b></td></tr>`,
                footerFormat: '</table>',
                shared: true,
                useHTML: true
            },
            plotOptions: {
                column: {
                    pointPadding: 0.2,
                    borderWidth: 0
                }
            },
            series: [i_versionData],
            credits: {
                enabled: false
            },
            legend: {
                enabled: false,
                shadow: false
            }
        };
        this.chartOptions = this._options;
        setTimeout(() => {
            this._ready = true;
        }, 6);
    }

    onSelect(e) {

    }
}



